<section [ngClass]="setCustomCss ? 'error-prompt custom' : 'error-prompt'">
  <div [ngClass]="setCustomCss ? 'error-prompt-body custom' : 'error-prompt-body'">
    <h1 class="error-prompt-title">
      {{ title }}
    </h1>

    <p class="error-prompt-explanation" [innerHtml]="explanation"></p>

    <p [ngClass]="setCustomCss ? 'error-prompt-instructions custom' : 'error-prompt-instructions'">
      <strong>
        {{ instructions }}
      </strong>
    </p>
  </div>

  <ng-content></ng-content>
</section>
